import { Pagination } from 'components/elements'
import { withSizes } from 'components/helpers'
import { isEmpty } from 'ramda'
import { useState } from 'react'
import { useQuery } from 'react-query'

import * as S from './SearchTopics.styles'
import { loadTags } from '../../modules/datasource'

const defaultProps = {}
const propTypes = {}

export const SearchTopics = ({ q, changePage, crrPage, isMobile }) => {
  const [listState, setListState] = useState([])

  const { isLoading } = useQuery(
    ['topics', { q, crrPage }],
    () => loadTags({ name: q, page: crrPage }),
    {
      fetchPolicy: 'no-cache',
      onSuccess: setListState,
    }
  )
  const { list = [], total } = listState

  return (
    <S.Container>
      {/* {isLoading && <Loading style={{ margin: '14px auto' }} />} */}
      <S.TagsContainer>
        {list?.map(({ name, slug }) => (
          <S.CustomFollowTag key={`topic-${slug}`} name={name} slug={slug} />
        ))}
      </S.TagsContainer>
      {!isLoading && isEmpty(list) && (
        <S.EmptyMessage>No topics found</S.EmptyMessage>
      )}
      {Math.ceil(total / 20) > 1 && (
        <Pagination
          style={{ marginTop: 32 }}
          count={Math.ceil(total / 20)}
          size={isMobile ? 'small' : 'medium'}
          color="primary"
          page={crrPage}
          onChange={(_, v) => {
            changePage(v)
          }}
        />
      )}
    </S.Container>
  )
}

SearchTopics.defaultProps = defaultProps
SearchTopics.propTypes = propTypes

export default withSizes(SearchTopics)
